import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { PROBLEMS } from '../lib/data';
export function Problems() {
  return <section className="px-4 py-8" data-id="element-188" data-mp="36x2e7jn7d3ux">
      <h2 className="text-center font-display text-2xl leading-tight text-white" data-id="element-189" data-mp="36y3sdwzim6gv">
        Jugar un partido de hockey hierba puede ser realmente difícil.
      </h2>

      <ul className="mt-6 space-y-3" data-id="element-190" data-mp="2y2xtlhynwonu">
        {PROBLEMS.map((p, i) => <li key={i} className="flex items-start gap-3 rounded-2xl border border-white/10 bg-hockey-card p-4" data-id="element-191" data-mp="2t4mhf0kwa22g" data-mpi={i}>
            <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-hockey-pink" data-id="element-192" data-mp="2o7cnp8qh348t" />
            <span className="text-[15px] leading-snug text-white/85" data-id="element-193" data-mp="2j6oucgerubbf">{p}</span>
          </li>)}
      </ul>
    </section>;
}